import styled from 'styled-components';
import { Label, Container } from './Styles';

const HeartContainer = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-family: ${(props) => props.theme.fonts.sansSerif};
  font-weight: 400;
  width: 27px;
  height: 27px;
  margin: 5px 0;
  cursor: pointer;
  border-radius: 22px;
  border: 2px solid var(--darkGrey);
  background: ${(props) => (!props.$isStared ? 'transparent' : '#fff')};
  svg {
    min-width: 13px;
    height: auto;
    margin-top: 1px;
  }
`;

const Heart = ({ clickEvent, isStared }) => (
  <Container>
    <HeartContainer
      title="Add to your favorites"
      role="button"
      $isStared={isStared}
      onClick={() => clickEvent()}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="102.828"
        height="89.414"
        viewBox="0 0 102.828 89.414"
      >
        <path
          d="M284.285,299.91c0,29.569-29.412,30.472-49.54,62.259a2.241,2.241,0,0,1-3.748,0c-20.127-31.787-49.54-32.691-49.54-62.259,0-16.252,13.412-26.143,26.735-26.143a28.863,28.863,0,0,1,24.678,13.987,28.864,28.864,0,0,1,24.678-13.987C270.873,273.767,284.285,283.658,284.285,299.91Z"
          transform="translate(-181.457 -273.767)"
        />
      </svg>
    </HeartContainer>
    <Label>{isStared ? 'Un-Favorite' : 'Favorite'}</Label>
  </Container>
);

export default Heart;
